<div class="loading-box">
  <img class="load" src="{{ 'assets/img/load_image.svg' | xeaSourcePath }}" />
</div>
